export default __webpack_public_path__ + "static/media/Sodium_Borate_Buffer.5c0c122c.svg";